import React from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import "./style.css";
import BerUns from "./views/ueber-uns";
import Datenschutz from "./views/datenschutz";
import Aktuelle from "./views/aktuelle";
import Kontakt from "./views/kontakt";
import NotFound from "./views/not-found";
import SinglePostView from "./views/single-post-view";
import Impressum from "./views/impresum-view";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Aktuelle />} />
        <Route path="/ueber-uns" element={<BerUns />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/news/:slug" element={<SinglePostView />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

const container = document.getElementById("app");
const root = createRoot(container);

root.render(<App />);
